import { render, staticRenderFns } from "./HomeSliderWidget.vue?vue&type=template&id=69fdfbdc&"
import script from "./HomeSliderWidget.vue?vue&type=script&lang=js&"
export * from "./HomeSliderWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-stylebreaker-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69fdfbdc')) {
      api.createRecord('69fdfbdc', component.options)
    } else {
      api.reload('69fdfbdc', component.options)
    }
    module.hot.accept("./HomeSliderWidget.vue?vue&type=template&id=69fdfbdc&", function () {
      api.rerender('69fdfbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/home/HomeSliderWidget.vue"
export default component.exports